<div class="input-group">
    <input
        placeholder="Nummer"
        [formControl]="formControl"
        [formlyAttributes]="field"
        autocomplete="no"
    />
    <div class="input-group-append">
        <p-button
            [disabled]="formControl.disabled"
            outlined="true"
            severity="secondary"
            pTooltip="{{ 'common.number-generator-button-tooltip' | translate }}"
            (onClick)="generateClick()"
            icon="fa fa-key"
        />
    </div>
</div>
